// extracted by mini-css-extract-plugin
export default {"root":"TwoFactorCodeGroupe_root__d+3Do","invalid":"TwoFactorCodeGroupe_invalid__bakiO","invalidText":"TwoFactorCodeGroupe_invalidText__j-g9U"};